
export default function About() {
  const stats = [
    { number: '500+', label: 'Condomínios Atendidos' },
    { number: '15+', label: 'Anos de Experiência' },
    { number: '50+', label: 'Profissionais Qualificados' },
    { number: '24/7', label: 'Suporte Disponível' }
  ];

  const values = [
    {
      icon: 'ri-time-line',
      title: 'Agilidade',
      description: 'Resposta rápida e execução eficiente em todos os nossos serviços.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Comprometimento',
      description: 'Dedicação total com a satisfação e necessidades dos nossos clientes.'
    },
    {
      icon: 'ri-award-line',
      title: 'Qualidade',
      description: 'Excelência em cada detalhe, utilizando os melhores materiais e técnicas.'
    },
    {
      icon: 'ri-team-line',
      title: 'Confiança',
      description: 'Profissionais qualificados e de confiança para cuidar do seu patrimônio.'
    }
  ];

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Sobre a PRIME SOLUÇÕES
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Há mais de 15 anos no mercado, somos especialistas em serviços para prédios e condomínios. 
              Nossa missão é oferecer soluções completas com agilidade e comprometimento, garantindo 
              a satisfação total dos nossos clientes.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Contamos com uma equipe de profissionais altamente qualificados e utilizamos as melhores 
              práticas do mercado para manter seu patrimônio sempre valorizado e bem cuidado.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-gray-600">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/8ef5d7ed9a3c57fd920a09263ca217f3.jpg"
              alt="Equipe PRIME SOLUÇÕES"
              className="rounded-2xl shadow-2xl w-full h-96 object-cover object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-orange-600 text-white p-6 rounded-2xl shadow-xl">
              <div className="text-2xl font-bold">15+</div>
              <div className="text-sm">Anos de Experiência</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${value.icon} text-3xl text-orange-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
